import ArticleIcon from '@mui/icons-material/Article';
import { Box, CircularProgress, Paper, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import AppPaperContent from 'src/app/common/components/AppPaperContent';
import AppPaperTitle from 'src/app/common/components/AppPaperTitle';
import { getBlob } from 'src/app/common/network/crud/resourceCrud';
import { dispatch } from 'src/utils/eventBus/eventBus';
import { usePoliciesApprovalRequestPageContext } from '../../PoliciesApprovalRequestPage.context';
import useStyles from './AdditionalInformation.styles';
import { useTranslation } from 'src/app/common/hook/translation.hook';

const UploadedFile = () => {
  const t = useTranslation();
  const { lmBatchFile } = usePoliciesApprovalRequestPageContext();
  const [isOpeningUrl, setIsOpeningUrl] = useState(false);
  const { classes } = useStyles();

  const openBlobUrl = async () => {
    if (!lmBatchFile?.document || isOpeningUrl) return;
    setIsOpeningUrl(true);
    try {
      const blob = (await getBlob({ resourceIds: lmBatchFile.document.blobId }, dispatch))?.[0];
      window.open(blob.url, '_blank', 'noopener,noreferrer');
    } catch (error) {
      // silently fail
    } finally {
      setIsOpeningUrl(false);
    }
  };

  return (
    <>
      <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 1 }}>
        {t('opm_pd.uploadedFile')}
      </Typography>
      {!!lmBatchFile?.document ? (
        <div className={classes.uploadFileItem}>
          <ArticleIcon color="primary" />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, overflow: 'hidden' }}>
            <Typography
              variant="body2"
              className={classes.uploadFileItemName}
              sx={{
                color: isOpeningUrl ? 'text.disabled' : 'primary.main',
                textDecoration: 'underline',
                cursor: isOpeningUrl ? 'default' : 'pointer',
              }}
              onClick={openBlobUrl}
            >
              {lmBatchFile?.document?.blobName}
            </Typography>
            {isOpeningUrl && <CircularProgress size={14} />}
          </Box>
        </div>
      ) : (
        <Typography variant="body2" color="text.secondary">
          {t('opm_pd.noFileUploaded')}
        </Typography>
      )}
    </>
  );
};

const AdditionalInformation = () => {
  const t = useTranslation();
  const { lmBatchFile } = usePoliciesApprovalRequestPageContext();

  return (
    <Paper>
      <AppPaperTitle>{t('opm_pd.additionalInformation')}</AppPaperTitle>
      <AppPaperContent sx={{ pt: 0 }}>
        <UploadedFile />
        <TextField
          multiline
          fullWidth
          value={lmBatchFile?.notes || ''}
          inputProps={{ readOnly: true }}
          label={t('opm_pd.note')}
          variant="outlined"
          sx={{ mt: 2 }}
        />
      </AppPaperContent>
    </Paper>
  );
};

export default AdditionalInformation;
